import { render, staticRenderFns } from "./Cost-Center.vue?vue&type=template&id=5effe242"
import script from "./Cost-Center.vue?vue&type=script&lang=js"
export * from "./Cost-Center.vue?vue&type=script&lang=js"
import style0 from "./Cost-Center.vue?vue&type=style&index=0&id=5effe242&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports